import React from "react";
import { Col, Row } from "react-bootstrap";
import { FaReact, FaServer, FaCloud, FaUserGraduate } from "react-icons/fa";

const services = [
  {
    icon: <FaReact />,
    title: "Web Development",
    desc: "Responsive websites & web apps built with the MERN stack.",
  },
  {
    icon: <FaServer />,
    title: "IT Support & Administration",
    desc: "Server management, Active Directory, hardware & network support.",
  },
  {
    icon: <FaCloud />,
    title: "Cloud & DevOps",
    desc: "Deployments on AWS & Azure, Docker containers, CI/CD pipelines.",
  },
  {
    icon: <FaUserGraduate />,
    title: "Tech Tutoring",
    desc: "Computer fundamentals, programming & web development coaching.",
  },
];

function Services() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {services.map((service, i) => (
        <Col xs={12} md={6} className="services-card" key={i}>
          <div className="services-icon">{service.icon}</div>
          <div className="services-title">{service.title}</div>
          <div className="services-desc">{service.desc}</div>
        </Col>
      ))}
    </Row>
  );
}

export default Services;